import { useEffect, useState } from "react";
import { api, fmtMoney } from "../../lib/api";
import { Wallet, RefreshCcw } from "lucide-react";

export default function SuperAdminPayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get("/superadmin/payments");
      setRows(data);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); }, []);

  const total = rows.reduce((s, p) => s + (Number(p.amount) || 0), 0);

  return (
    <div className="p-6 sm:p-8 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-black tracking-tight" data-testid="sa-payments-title">Pagamenti</h1>
        <button
          onClick={load}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-slate-700 hover:border-rose-500 hover:bg-rose-500/10 text-sm text-slate-300"
        >
          <RefreshCcw size={14}/> Ricarica
        </button>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <div className="rounded-xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/15 to-emerald-500/5 p-4">
          <div className="text-[10px] tracking-widest uppercase font-bold text-emerald-300 flex items-center gap-2">
            <Wallet size={14}/> Revenue totale
          </div>
          <div className="text-2xl font-black font-mono mt-2">{fmtMoney(total)} €</div>
        </div>
        <div className="rounded-xl border border-sky-500/30 bg-gradient-to-br from-sky-500/15 to-sky-500/5 p-4">
          <div className="text-[10px] tracking-widest uppercase font-bold text-sky-300">Transazioni</div>
          <div className="text-2xl font-black font-mono mt-2">{rows.length}</div>
        </div>
        <div className="rounded-xl border border-slate-700 bg-slate-800/40 p-4 text-slate-400 text-sm flex items-center">
          Stripe in arrivo: i pagamenti reali appariranno qui una volta integrato il webhook <code className="ml-1">checkout.session.completed</code>.
        </div>
      </div>

      <div className="bg-slate-900/60 border border-slate-800 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-950/70 text-[10px] uppercase tracking-widest text-slate-400">
              <tr>
                <th className="px-4 py-3 text-left">ID</th>
                <th className="px-4 py-3 text-left">Lega</th>
                <th className="px-4 py-3 text-left">Utente</th>
                <th className="px-4 py-3 text-right">Importo</th>
                <th className="px-4 py-3 text-center">Stato</th>
                <th className="px-4 py-3 text-left">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800">
              {loading ? (
                <tr><td colSpan={6} className="p-8 text-center text-slate-500">Caricamento…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={6} className="p-8 text-center text-slate-500">
                  Nessun pagamento registrato. In attesa dei primi checkout Stripe (69 € standard · 39 € sconto prima lega fuori stagione).
                </td></tr>
              ) : rows.map((p) => (
                <tr key={p.payment_id || p.stripe_session_id} className="hover:bg-slate-800/30">
                  <td className="px-4 py-3 font-mono text-xs">{p.payment_id || p.stripe_session_id}</td>
                  <td className="px-4 py-3">{p.league_name || p.league_id || "—"}</td>
                  <td className="px-4 py-3">{p.user_email || "—"}</td>
                  <td className="px-4 py-3 text-right font-mono">{fmtMoney(p.amount || 0)} {p.currency || "€"}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`text-[10px] uppercase px-2 py-1 rounded border font-bold ${
                      p.status === "succeeded"
                        ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300"
                        : "border-slate-700 bg-slate-800 text-slate-400"
                    }`}>{p.status || "—"}</span>
                  </td>
                  <td className="px-4 py-3 text-xs font-mono text-slate-400">{(p.created_at || "").slice(0, 16).replace("T", " ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
